import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export type ParamsType = {
  memberId: string | string[]
}

// 取得User Profile (無需驗證)
class FetchUserProfileApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_USER_PROFILE'

    this.config = {
      url: `/v1/user/profile/${params.memberId}`,
      method: 'GET',
      params: { cache: 0 }, // 避免拿到 CDN/gateway 快取的舊資料（完善個資後要即時反映）
    }
  }
}

export const fetchUserProfile = (params: ParamsType) => getCallApiFunction(new FetchUserProfileApi(params))
